
//Dependencies
import React, { Component } from 'react';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';


class PlazoFijoSelect extends Component {
    constructor(props){
      super(props);

      this.isValid = this.isValid.bind(this);
      this.handleChange = this.handleChange.bind(this);

    }

  isValid(){
    if( !!this.props.optional ){
      return true
    }
    
    return !!this.props.value === true && this.props.value !== -1
  }

  /*shouldComponentUpdate(nextProps, nextState) {
    if( nextProps.value !== this.props.value || 
        nextProps.values !== this.props.values || 
        nextProps.externalSubmitted !== this.props.externalSubmitted ){
        
        console.log("REPINTANDO: " + this.props.name)

        return true
    }

    return false;
  }*/

  handleChange(e){
    console.log("---------handleChange-------------")
    this.props.setItem(e)
  }

  render() {
    let {
          value = "",
          keyId = "id",
          keyValue = "data", 
          values = [], 
          label ,
          name, 
          errorMessage="error",
          externalSubmitted=false
        } = this.props


        let errorTag = null
        let errorStyle = false
        if(externalSubmitted && !this.isValid()){
          errorTag = <FormHelperText style={{color:"red"}}>{errorMessage}</FormHelperText>
          errorStyle = true
        }

        return (
            <FormControl className="ip-form-control" error={errorStyle}>
                <InputLabel htmlFor={name}>{label} </InputLabel>
                <Select onChange={this.handleChange} name={name} value={value}>
                      {
                        values.map((value, key) => {
                            return <MenuItem value={value[keyId]} key={key} >{value[keyValue]}</MenuItem>
                        })
                      }
                    <MenuItem value={-1}>Seleccioná</MenuItem>
                </Select>
                {errorTag}
            </FormControl>
        );
  }
}

export default PlazoFijoSelect;



// WEBPACK FOOTER //
// ./src/components/PlazoFijo/common/components/PlazoFijoSelect.js